import { Component, OnInit, Input } from "@angular/core";
import { ControlValueAccessor, UntypedFormControl } from "@angular/forms";

import { createCustomInputControlValueAccessor } from "../../Helpers/form.helper";

@Component({
  selector: "app-search-by-drop-down",
  templateUrl: "./search-by-drop-down.component.html",
  providers: [createCustomInputControlValueAccessor(SearchByDropDownComponent)],
})
export class SearchByDropDownComponent implements OnInit, ControlValueAccessor {
  public searchTerm: UntypedFormControl;
  @Input() public label = "Buscar por";
  @Input() public searchTerms: string[];
  @Input() public placeholder = "Seleccionar";

  public ngOnInit(): void {
    this.searchTerm = new UntypedFormControl();
  }

  public writeValue(value: string): void {
    if (value) {
      this.searchTerm.setValue(value, { emitEvent: true });
    }
  }

  public registerOnChange(fn: (value: string) => void): void {
    this.searchTerm.valueChanges.subscribe(fn);
  }

  public registerOnTouched(fn: () => void): void {
    this.searchTerm.markAsTouched();
    fn();
  }

  public setDisabledState?(isDisabled: boolean): void {
    isDisabled
      ? this.searchTerm.disable({ emitEvent: false, onlySelf: true })
      : this.searchTerm.enable({ emitEvent: false, onlySelf: true });
  }
}
